<template>
  <div>
    <v-dialog v-model="show" max-width="600px">
      <v-card>
        <div class="sticky-header">
          <v-sheet class="px-0 py-4 blue darken-2">
            <div
              class="d-flex justify-space-between"
            >
              <v-card-title class="white--text">Categories</v-card-title>
              <v-btn
                class="mx-4"
                icon
                small
                @click="show = false"
              >
                <v-icon class="white--text">mdi-close</v-icon>
              </v-btn>
            </div>
            <div class="px-4">
              <v-text-field
                v-model="search"
                label="Search"
                :append-icon="!search ? 'mdi-magnify' : null"
                dark
                flat
                solo-inverted
                hide-details
                clearable
                clear-icon="mdi-close-circle-outline"
              ></v-text-field>
            </div>
          </v-sheet>
        </div>
        <v-card-text class="pl-4 pr-0 pb-0">
          <v-treeview
            :items="paginatedCategories"
            item-text="Name"
            item-children="Subcategories"
            item-key="Item_Key"
            :search="search"
            dense
            open-on-click
            return-object
            hoverable
          >
            <template v-slot:append="{ item, open }">
              <v-tooltip
                bottom
                color="success"
                v-if="item.Category && item.Item_ID"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-show="!editingItem || editingItem.Item_Key !== item.Item_Key"
                    :disabled="ifSomeModesOn"
                    small
                    v-bind="attrs"
                    v-on="on"
                    icon
                    color="success"
                    @click="addNewSubcategory(item, open, $event)"
                  >
                    <v-icon>mdi-plus-circle</v-icon>
                  </v-btn>
                </template>
                <span>Add new</span>
              </v-tooltip>
              <v-tooltip bottom color="primary">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-show="!editingItem || editingItem.Item_Key !== item.Item_Key"
                    :disabled="ifSomeModesOn"
                    small
                    v-bind="attrs"
                    v-on="on"
                    icon color="primary"
                    @click.stop="editCategory(item)"
                  >
                    <v-icon>mdi-pencil-circle</v-icon>
                  </v-btn>
                </template>
                <span>Edit</span>
              </v-tooltip>
              <v-tooltip bottom color="red darken-2">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-show="!editingItem || editingItem.Item_Key !== item.Item_Key"
                    :disabled="ifSomeModesOn"
                    small
                    v-bind="attrs"
                    v-on="on"
                    icon color="red darken-2"
                    @click.stop=" showDeleteCategoryDialog(item)"
                  >
                    <v-icon>mdi-delete-circle</v-icon>
                  </v-btn>
                </template>
                <span>Delete</span>
              </v-tooltip>
              <v-tooltip bottom color="success">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-show="(modes.edit || modes.add) && editingItem && editingItem.Item_Key === item.Item_Key"
                    :disabled="((modes.add || modes.edit) && !item.Name) || /[а-яА-ЯЁёҐґЄєІіЇї]/.test(item.Name)"
                    small
                    v-bind="attrs"
                    v-on="on"
                    icon color="success"
                    @click.stop="saveItem(item)"
                  >
                    <v-icon>mdi-check-circle</v-icon>
                  </v-btn>
                </template>
                <span>Save</span>
              </v-tooltip>
              <v-tooltip bottom color="primary">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-show="(modes.edit || modes.add) && editingItem && editingItem.Item_Key === item.Item_Key"
                    small
                    v-bind="attrs"
                    v-on="on"
                    icon color="primary"
                    @click.stop="cancelEditing"
                  >
                    <v-icon>mdi-close-circle</v-icon>
                  </v-btn>
                </template>
                <span>Cancel</span>
              </v-tooltip>
            </template>
            <template v-slot:label="{ item }">
              <div>
                <span v-if="editingItem === item">
                  <v-text-field
                    v-model="item.Name"
                    autofocus
                    :rules="rules.required.concat([rules.englishOnly])"
                    @keyup.enter="saveItem(item)"
                  >
                  </v-text-field>
                </span>
                <span v-else>{{ item.Name }}</span>
              </div>
            </template>
          </v-treeview>
        </v-card-text>

        <v-divider></v-divider>
        <div class="d-flex align-center justify-end pa-2 grey--text text--darken-1" style="font-size: 12px;">
          <span class="mx-2">Rows per page:</span>
          <v-select
            v-model="itemsPerPage"
            :items="[10, 20, 50, {text:'All', value: -1}]"
            dense
            hide-details
            style="max-width: 70px; font-size: 12px;"
            class="mt-0 pt-0"
          ></v-select>
          <span class="mx-4">{{ paginationInfo }}</span>
          <v-btn icon small :disabled="page === 1" @click="page--">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn icon small :disabled="page >= Math.ceil(categoriesTree.length / itemsPerPage) || itemsPerPage === -1" @click="page++">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </div>

        <v-divider></v-divider>
        <v-card-actions class="sticky-bottom pa-3">
          <v-spacer></v-spacer>
          <v-btn
            :disabled="ifSomeModesOn"
            color="success"
            small
            @click="addNewCategory"
          >
            Add Category
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmOrDeniedDialog
      v-if="deleteAssetCategoryDialog"
      v-model="deleteAssetCategoryDialog"
      :mode="confirmOrDeniedDialogModes.delete"
      @onDeleteClick="deleteAssetCategory"
      @onCancelClick="cancelDeleting"
      @onCloseClick="cancelDeleting"
    />
  </div>
</template>

<script>
import { getApiErrorMessage } from '@/utils/apiError'
export default {
  name: 'AssetCategoriesManagerNew',
  components: {
    ConfirmOrDeniedDialog: () => import('@/components/global/ConfirmOrDeniedDialog.vue')
  },
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      page: 1,
      itemsPerPage: 10,

      caseSensitive: false,
      addCategory: true,
      addSubcategory: true,
      beforeModifiedItemCopy: null,
      categoriesTree: [],
      categoryToRemove: null,
      deleteAssetCategoryDialog: false,
      editingItem: null,
      indexOfModifiedNode: null,
      indexCategoryToRemove: null,
      indexOfModifiedSubCategory: null,
      search: null,
      modes: {
        add: false,
        edit: false,
        delete: false
      },
      rules: {
        required: [v => !!v || 'Required'],
        englishOnly: v => !/[а-яА-ЯЁёҐґЄєІіЇї]/.test(v) || 'English only'
      }
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    confirmOrDeniedDialogModes () {
      return this.$store.getters.getConfirmOrDeniedDialogModes
    },
    ifSomeModesOn () {
      return this.modes.add || this.modes.edit || this.modes.delete
    },
    paginatedCategories () {
      if (this.search || this.itemsPerPage === -1) {
        return this.categoriesTree
      }
      const start = (this.page - 1) * this.itemsPerPage
      const end = start + this.itemsPerPage
      return this.categoriesTree.slice(start, end)
    },
    paginationInfo () {
      if (this.itemsPerPage === -1) return `1-${this.categoriesTree.length} of ${this.categoriesTree.length}`
      const start = (this.page - 1) * this.itemsPerPage + 1
      const end = Math.min(this.page * this.itemsPerPage, this.categoriesTree.length)
      return `${start}-${end} of ${this.categoriesTree.length}`
    }
  },
  watch: {
    search () {
      this.page = 1
    },
    itemsPerPage () {
      this.page = 1
    }
  },
  mounted () {
    this.getAssetCategories()
  },
  methods: {
    addNewCategory () {
      if (this.search) {
        this.search = null
      }
      this.modes.add = true
      const newCategory = {
        Item_ID: null,
        Item_Key: new Date().getTime(),
        Name: '',
        Category: true,
        Subcategories: []
      }
      this.editingItem = newCategory
      this.indexOfModifiedNode = this.categoriesTree.length
      this.categoriesTree.push(newCategory)
      if (this.itemsPerPage !== -1) {
        this.page = Math.ceil(this.categoriesTree.length / this.itemsPerPage)
      }
    },
    addNewSubcategory (item, open, e) {
      if (this.search) {
        this.search = null
      }
      this.modes.add = true
      if (open) {
        e.stopPropagation()
      }
      this.indexOfModifiedNode = this.categoriesTree.findIndex(el => el.Item_ID === item.Item_ID)
      const newSubcategory = {
        Item_ID: null,
        Item_Key: new Date().getTime(),
        Name: '',
        Subcategory: true,
        Category_ID: this.categoriesTree[this.indexOfModifiedNode].Item_ID
      }
      this.editingItem = newSubcategory
      this.indexOfModifiedSubCategory = this.categoriesTree[this.indexOfModifiedNode].Subcategories.length
      this.categoriesTree[this.indexOfModifiedNode].Subcategories.push(newSubcategory)
    },
    editCategory (item) {
      this.modes.edit = true
      this.beforeModifiedItemCopy = { ...item }
      this.editingItem = item
      if (item.Category) {
        this.indexOfModifiedNode = this.categoriesTree.findIndex(el => el.Item_ID === item.Item_ID)
      } else if (item.Subcategory) {
        this.indexOfModifiedNode = this.categoriesTree.findIndex(el => el.Item_ID === item.Category_ID)
        this.indexOfModifiedSubCategory = this.categoriesTree[this.indexOfModifiedNode].Subcategories.findIndex(el => el.Item_ID === item.Item_ID)
      }
    },
    cancelEditing () {
      if (this.modes.add) {
        if (this.editingItem.Category) {
          this.categoriesTree.pop()
        } else if (this.editingItem.Subcategory) {
          this.categoriesTree[this.indexOfModifiedNode].Subcategories.pop()
        }
        this.modes.add = false
      } else if (this.modes.edit) {
        if (this.editingItem.Category) {
          this.categoriesTree[this.indexOfModifiedNode].Name = this.beforeModifiedItemCopy.Name
        } else if (this.editingItem.Subcategory) {
          this.categoriesTree[this.indexOfModifiedNode].Subcategories[this.indexOfModifiedSubCategory].Name = this.beforeModifiedItemCopy.Name
        }
        this.indexOfModifiedSubCategory = null
        this.indexOfModifiedNode = null
        this.beforeModifiedItemCopy = null
        this.modes.edit = false
      }
      this.editingItem = null
    },
    saveItem (item) {
      if (item.Subcategory && !item.Item_ID && this.modes.add) {
        const body = {
          Asset_Subcategory_ID: item.Item_ID,
          Asset_Category_ID: item.Category_ID,
          Subcategory_Name: item.Name
        }
        this.postCategory('/api/asset_subcategory', body)
      } else if (item.Category && !item.Item_ID && this.modes.add) {
        const body = {
          Category_Name: item.Name,
          Subcategories: item.Subcategories
        }
        this.postCategory('/api/asset_category', body)
      } else if (item.Category && item.Item_ID && this.modes.edit) {
        const body = {
          Asset_Category_ID: this.editingItem.Item_ID,
          Category_Name: this.editingItem.Name
        }
        this.updateCategory('/api/asset_category/', body)
      } else if (item.Subcategory && item.Item_ID && this.modes.edit) {
        const body = {
          Asset_Subcategory_ID: this.editingItem.Item_ID,
          Asset_Category_ID: this.editingItem.Category_ID,
          Subcategory_Name: this.editingItem.Name
        }
        this.updateCategory('/api/asset_subcategory/', body)
      }
    },
    showDeleteCategoryDialog (item) {
      if (item.Category) {
        this.indexCategoryToRemove = this.categoriesTree.findIndex(el => el.Item_ID === item.Item_ID)
        this.categoryToRemove = item
      } else {
        this.indexOfModifiedNode = this.categoriesTree.findIndex(el => el.Item_ID === item.Category_ID)
        this.indexCategoryToRemove = this.categoriesTree[this.indexOfModifiedNode].Subcategories.findIndex(el => el.Item_ID === item.Item_ID)
        this.categoryToRemove = item
      }
      this.modes.delete = true
      this.deleteAssetCategoryDialog = true
    },
    cancelDeleting () {
      this.modes.delete = false
      this.categoryToRemove = null
      this.indexCategoryToRemove = null
      this.indexOfModifiedNode = null
    },
    getAssetCategories () {
      this.axios.get('/api/asset_categories', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.categoriesTree = this.generateGroupsOfCategories(res.data[0], res.data[1])
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    postCategory (url, item) {
      this.axios.post(url, item, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        const modifiedCategory = this.categoryModification(res.data[0])
        if (modifiedCategory.Category) {
          this.categoriesTree.splice(this.indexOfModifiedNode, 1, modifiedCategory)
        } else if (modifiedCategory.Subcategory) {
          this.categoriesTree[this.indexOfModifiedNode].Subcategories.splice(this.indexOfModifiedSubCategory, 1, modifiedCategory)
        }

        this.indexOfModifiedSubCategory = null
        this.indexOfModifiedNode = null
        this.editingItem = null
        this.modes.add = false
        this.$store.dispatch('setSuccess', { successMsg: 'Changes successfully added' })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    updateCategory (url, body) {
      this.axios.put(`${url}${this.editingItem.Item_ID}`, body, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setSuccess', { successMsg: 'Changes successfully updated' })
        this.editingItem = null
        this.indexOfModifiedSubCategory = null
        this.indexOfModifiedNode = null
        this.beforeModifiedItemCopy = null
        this.modes.edit = false
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    deleteAssetCategory () {
      let url = ''
      if (this.categoryToRemove.Category) {
        url = '/api/asset_category/'
      } else {
        url = '/api/asset_subcategory/'
      }

      if (this.categoryToRemove && url && this.modes.delete) {
        this.axios.delete(`${url}${this.categoryToRemove.Item_ID}`, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          if (this.categoryToRemove.Category) {
            this.categoriesTree.splice(this.indexCategoryToRemove, 1)
          } else {
            this.categoriesTree[this.indexOfModifiedNode].Subcategories.splice(this.indexCategoryToRemove, 1)
          }
          this.$store.dispatch('setSuccess', { successMsg: 'Successfully deleted' })
          this.deleteAssetCategoryDialog = false
          this.cancelDeleting()
        }).catch(error => {
          const errorMsg = getApiErrorMessage(error)
          this.$store.dispatch('setError', { errorMsg })
        })
      }
    },
    generateGroupsOfCategories (categories, subcategories) {
      const groupsOfCategories = []
      const categoryMap = {}

      categories.forEach(el => {
        categoryMap[el.Asset_Category_ID] = {
          Item_ID: el.Asset_Category_ID,
          Item_Key: `${el.Asset_Category_ID}_${el.Category_Name}`,
          Name: el.Category_Name,
          Category: true,
          Subcategories: []
        }
      })
      subcategories.forEach(el => {
        if (categoryMap[el.Asset_Category_ID]) {
          categoryMap[el.Asset_Category_ID].Subcategories.push({
            Item_ID: el.Asset_Subcategory_ID,
            Item_Key: `${el.Asset_Subcategory_ID}_${el.Subcategory_Name}`,
            Name: el.Subcategory_Name,
            Subcategory: true,
            Category_ID: el.Asset_Category_ID
          })
        }
      })
      Object.keys(categoryMap).forEach(categoryID => {
        groupsOfCategories.push(categoryMap[categoryID])
      })
      return groupsOfCategories
    },
    categoryModification (category) {
      if (category.Asset_Category_ID && !category.Asset_Subcategory_ID) {
        return {
          Item_ID: category.Asset_Category_ID,
          Item_Key: `${category.Asset_Category_ID}_${category.Category_Name}`,
          Name: category.Category_Name,
          Category: true,
          Subcategories: []
        }
      } else if (category.Asset_Subcategory_ID && category.Asset_Category_ID) {
        return {
          Item_ID: category.Asset_Subcategory_ID,
          Item_Key: `${category.Asset_Subcategory_ID}_${category.Subcategory_Name}`,
          Name: category.Subcategory_Name,
          Subcategory: true,
          Category_ID: category.Asset_Category_ID
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-dialog {
    transform-origin: center center;
  }
  .v-treeview-node__root {
    cursor: pointer;
  }
  .v-treeview {
    min-height: 400px;
  }
}

.sticky-header {
  position: sticky;
  top: 0;
  z-index: 2;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 2;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  background: white;
}

.theme--dark {
  .sticky-bottom {
    border-top-color: rgba(255, 255, 255, 0.12);
    background: #1e1e1e;
  }
}
</style>
